import { render, staticRenderFns } from "./yearPlan.vue?vue&type=template&id=13fb1028&scoped=true&"
import script from "./yearPlan.vue?vue&type=script&lang=js&"
export * from "./yearPlan.vue?vue&type=script&lang=js&"
import style0 from "./yearPlan.vue?vue&type=style&index=0&id=13fb1028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb1028",
  null
  
)

export default component.exports